<!--suppress ALL -->
<script lang="ts">
import {pendidikanFormals} from '../../../util/PluralVariabels';
import {Component, Vue, Prop} from 'annotation';
import {cloneArray} from "../../../util/Underscore";

import GField from '../common/field/GField.vue';
import GSelect from '../common/select/GSelect.vue';

@Component
export default class PendidikanFormalSelect extends Vue {

  @Prop({default: pendidikanFormals[0].value, type: String})
  public pendidikan: string;

  @Prop({default: false, type: Boolean})
  public skipLabel: boolean;

  @Prop({default: true, type: Boolean})
  public isFullwidth: boolean;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  @Prop({type: Boolean, default: false})
  public disabled: any;

  public onSelectPendidikan(param: any) {
    this.$emit('update:pendidikan', param.value || pendidikanFormals[0].value);
    this.$emit('selected', param);
  }

  public render(createElement: Function) {
    const {$t, pendidikan, isFullwidth, message, type} = this;

    const mainAttr: any = {
      props: {
        value: pendidikan,
        isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.pendidikan')} Formal`
      },
      attrs: {disabled: this.disabled},
      on: {change: this.onSelectPendidikan}
    };

    const main: any = createElement(GSelect, mainAttr, cloneArray(pendidikanFormals).map((item: any) => {
      const option: any = {attrs: {value: item.value}};

      return createElement('option', option, item.name.toUpperCase());
    }));

    if (this.skipLabel) {
      return main;
    }

    return createElement(GField, {props: {label: `${$t('label.pendidikan')} Formal`, message, type}}, [main]);
  }
}
</script>
